import { ReactNode } from 'react';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import Styles from './NSDialog.module.css';

export interface NSDialogProps extends IBaseComponentProps
{
	onClose: () => void;
	children: ReactNode;
	center_dialog?: boolean;
	closeButton?: {
		show?: boolean;
		out?: boolean;
	}
}

export function NSDialog(props: NSDialogProps)
{
	return (
		<section
			id={props.id}
			className={props.center_dialog ? Styles.ns_dialog_center_container : Styles.ns_dialog_container}
		>
			<div className={Styles.ns_dialog_background} onClick={() => props.onClose()}>
			</div>
			<div
				className={`${Styles.ns_dialog_content} ${props.classList?.join(" ") ?? ""}`}
				style={{ ...props.style }}
			>
				{
					props.closeButton?.show !== false && <div
						onClick={() => props.onClose()}
						style=
						{{
							position: "absolute",
							top: (props.closeButton?.out) ? "-60px" : "0px",
							right: 0,
							transform: "translate(-40%,40%)",
							cursor: "pointer",
							width: "24px",
							height: "24px",
						}}
					>
						<img
							src={(props.closeButton?.out) ? 'https://static.namirasoft.com/image/concept/close/white.svg' : 'https://static.namirasoft.com/image/concept/close/blue.svg'}

							alt='close'
							width={24}
							height={24}
							style=
							{{
								position: "absolute"
							}}
							onClick={() => props.onClose()} />
					</div>
				}
				<div className={Styles.ns_dialog_children}>
					{props.children}
				</div>
			</div>
		</section >
	);
}